module.exports = __webpack_public_path__ + "static/media/user_512.7edc1649.png";